import React from "react";

// Under a VIN input: makes zeros unmistakable (slashed glyph + count) and explains
// that O / I / Q are swapped to 0 / 1 / 0 automatically (they never appear in a VIN).
export function VinHint({ value, testid = "vin-hint" }) {
  const v = String(value || "");
  if (!v) return <div className="text-[11px] text-slate-400 mt-1" data-testid={testid}>17 characters · typing the letter O, I or Q becomes 0, 1, 0 (never used in a VIN)</div>;
  const zeros = (v.match(/0/g) || []).length;
  return (
    <div className="text-[11px] text-slate-500 mt-1 flex flex-wrap items-center gap-x-2" data-testid={testid}>
      <span className="vin-glyphs tracking-widest">
        {v.split("").map((ch, i) => (
          <span key={i} className={ch === "0" ? "text-red-700 font-bold" : ""}>{ch}</span>
        ))}
      </span>
      <span>· {v.length}/17</span>
      <span>· <b className="text-red-700">{zeros}</b> zero{zeros === 1 ? "" : "s"} (shown slashed Ø — the letter O never appears in a VIN)</span>
    </div>
  );
}
